import notificationBell from 'utils/_notification_bell.js'
import ajaxOpenButton from 'utils/_ajax-open-button.js'
import accountOrderDetail from '3-section/section-account-order-detail/_index.js'
import updateListCommon from 'utils/_update-list-common.js'

export default (data) => {

  updateListCommon(data)

  document.querySelectorAll('.order-list__open').forEach((e) => {ajaxOpenButton(
    e,
    '.order-list__body-item',
    '/{!_locale}/account/orders/{!id}',
    accountOrderDetail(
      '#order-status-history-link',
      '#order-status-history-close'
    )
  )})

  notificationBell()
}

